export const PASSWORD_CHANGED_WITHIN_24_HOURS = 'password changed within 24 hours';
export const PASSWORD_MATCHES_RECENT_HISTORY = 'password matches recent password history';

const PASSWORD_POLICY_ERROR_MESSAGE_KEYS = {
	[PASSWORD_CHANGED_WITHIN_24_HOURS]: 'share:auth:reset_password:policy:changed_within_24_hours',
	[PASSWORD_MATCHES_RECENT_HISTORY]: 'share:auth:reset_password:policy:matches_recent_password_history',
};

export const getPasswordPolicyErrorMessageKey = errorType => PASSWORD_POLICY_ERROR_MESSAGE_KEYS[errorType] || null;

export const isPasswordPolicyError = errorType => Boolean(getPasswordPolicyErrorMessageKey(errorType));
